if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.formInput = this.form?.querySelector("[name=id]");
        if (this.formInput) this.formInput.disabled = false;
        this.form?.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart = document.querySelector("cart-drawer");
        this.cartType = this.cart?.dataset.cartType;

        this.submitButton = this.querySelector('[type="submit"]');
        this.body = document.querySelector("body");

        if (document.querySelector("cart-drawer"))
          this.submitButton?.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";

        this.handleErrorMessage = this.handleErrorMessage.bind(this);
        this.redirectAfterSubmit = this.redirectAfterSubmit.bind(this);
        this.disableLoadingInButton = this.disableLoadingInButton.bind(this);
      }

      closeComplementaryProduct() {
        const complementaryOverlayPage = document.querySelector(
          ".wt__quick-buy--page-overlay",
        );
        if (this.body.classList.contains("quick-buy-page-overlay"))
          this.body.classList.remove("quick-buy-page-overlay");
        if (
          complementaryOverlayPage.classList.contains(
            "wt__quick-buy--page-overlay--open",
          )
        )
          complementaryOverlayPage.classList.remove(
            "wt__quick-buy--page-overlay--open",
          );
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();
        this.cart?.setActiveElement(document.activeElement);

        // Check max order limit including existing cart quantity
        const maxOrderLimit = this.getAttribute('data-max-order-limit');
        if (maxOrderLimit) {
          const quantityInput = this.form.querySelector('[name="quantity"]');
          const quantity = quantityInput ? parseInt(quantityInput.value) : 1;
          const limit = parseInt(maxOrderLimit);
          const variantId = this.formInput.value;
          
          // Get current cart data to check existing quantity
          try {
            const response = await fetch('/cart.js');
            const cartData = await response.json();
            
            // Find existing items excluding free gifts
            const existingItems = cartData.items.filter(item => {
              if (item.variant_id.toString() !== variantId) return false;
              
              // Exclude free gifts
              if (item.price === 0) return false;
              
              if (item.properties) {
                for (const [key, value] of Object.entries(item.properties)) {
                  const lowerKey = key.toLowerCase();
                  if (lowerKey.includes('gift') || lowerKey.includes('free') || 
                      lowerKey === '_is_gift' || lowerKey === 'is_gift' ||
                      lowerKey === '_gift' || lowerKey === 'gift_with_purchase') {
                    return false;
                  }
                }
              }
              
              if (item.line_price === 0 && item.original_line_price > 0) return false;
              
              return true;
            });
            
            const existingQuantity = existingItems.reduce((total, item) => total + item.quantity, 0);
            const totalQuantity = existingQuantity + quantity;
            
            if (totalQuantity > limit) {
              // Always use the localized base message
              let errorMessage = window.quantityLimitStrings?.limitMessage?.replace('[limit]', limit) || `Maximum ${limit} per order`;
              
              if (existingQuantity >= limit) {
                const alreadyInCartText = window.quantityLimitStrings?.alreadyInCart?.replace('[quantity]', existingQuantity) || `You already have ${existingQuantity} in your cart`;
                errorMessage += `. ${alreadyInCartText}`;
              } else {
                const allowedQuantity = limit - existingQuantity;
                const canAddMoreText = window.quantityLimitStrings?.canAddMore?.replace('[existing]', existingQuantity).replace('[remaining]', allowedQuantity) || `You already have ${existingQuantity} in cart, can add ${allowedQuantity} more`;
                errorMessage += `. ${canAddMoreText}`;
              }
              this.handleErrorMessage(errorMessage);
              return;
            }
          } catch (error) {
            console.error('Error checking cart quantity:', error);
          }
        }

        const loader = this.querySelector(".loading-overlay__spinner");

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        if (loader) loader.classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        formData.append(
          "sections",
          this.cart.getSectionsToRender().map((section) => section.id),
        );
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.error = true;

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");

                this.dispatchEvent(new CustomEvent('cart-drawer:refresh', {
                  detail: { 'response': response },
                  bubbles: true,
                  composed: true
                }));

              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.redirectAfterSubmit(response);
                  });
                },
                { once: true },
              );
              if (this.cartType === "drawer") quickAddModal.hide(true);
            } else {
              const isClosedCart = !document.body.classList.contains(
                "page-overlay-cart-on",
              );
              this.redirectAfterSubmit(response, isClosedCart);
            }
          })
          .catch((e) => {
            console.error(e);
            if (e instanceof TypeError && e.message.includes("'cart-drawer'")) {
              location.reload();
            }
          })
          .finally(() => {
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            this.submitButton.removeAttribute("aria-disabled");
            if (this.error) {
              this.disableLoadingInButton();
              return;
            }
            this.quick_add_container = document.querySelector(
              ".wt__quick-buy__container",
            );
            this.quick_add_overlay = document.querySelector(
              ".wt__quick-buy--page-overlay",
            );
            this.quick_add_product =
            this.quick_add_container.querySelector(".wt-product");
            this.loader = this.quick_add_container.querySelector(
              ".wt__quick-buy-loader",
            );
            
            if (!this.quick_add_container.classList.contains("hidden")) {
              // use handle and quickbuy closeCart()
              
              this.quick_add_product?.remove();
              this.quick_add_container.classList.remove(
                "wt__quick-buy__container--open",
              );
              this.quick_add_overlay.classList.remove(
                "wt__quick-buy--page-overlay--open",
              );
              document.body.classList.remove("quick-buy-page-overlay");
              this.loader.classList.remove("hidden");
            }

            // delay button loading
            setTimeout(() => {
              this.disableLoadingInButton();
            }, 200)
          })
        }
        
        disableLoadingInButton() {
        this.submitButton.classList.remove("loading");
        this.querySelector(".loading-overlay__spinner").classList.add("hidden");
      }

      redirectAfterSubmit(response, isClosedCart = true) {
        const body = document.body;
        const isCartPage = body.classList.contains("template-cart");

        if (this.cartType === "drawer" && isCartPage) {
          const overlay = document.querySelector(
            ".wt__quick-buy--page-overlay",
          );
          overlay.classList.remove("wt__quick-buy--page-overlay--open");
          body.classList.remove("quick-buy-page-overlay");
        } else if (this.cartType === "drawer") {
          this.cart.renderContents(response, isClosedCart);
          return;
        }
        window.location = window.routes.cart_url;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        // For quantity limit errors, use the same styling as the + button messages
        if (errorMessage && (errorMessage.includes('Maksimalno') || errorMessage.includes('Maximum') || errorMessage.includes('per order'))) {
          // Remove any existing quantity limit message
          const existingMessage = this.querySelector('.quantity-limit-message');
          if (existingMessage) existingMessage.remove();
          
          if (errorMessage) {
            // Create message with same styling as quantity limit messages
            const message = document.createElement('div');
            message.className = 'quantity-limit-message quantity-limit-message--error';
            message.textContent = errorMessage;
            
            // Insert at top of form wrapper
            const formWrapper = this.querySelector('.wt-product__add-to-cart_form--wrapper');
            if (formWrapper) {
              formWrapper.insertBefore(message, formWrapper.firstChild);
            } else {
              this.insertBefore(message, this.firstChild);
            }
            
            // Auto-hide after 5 seconds
            setTimeout(() => {
              message.classList.add('fade-out');
              setTimeout(() => message.remove(), 300);
            }, 5000);
          }
          return;
        }

        // For other errors, use the default error handling
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}
